var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function removeElementFromArray(array, index) {
    return rearrangeItemInArray(array, index);
}
export function moveElementInArray(array, index, offset) {
    var newIndex = index + offset;
    return rearrangeItemInArray(array, index, newIndex);
}
// export function addItemToArray(array: any[], itemsToAdd: any[]): any[]
export function addItemToArray(array, itemsToAdd, atIndex) {
    if (atIndex === void 0) { atIndex = array.length; }
    var newArray = __spreadArray([], array, true);
    newArray.splice.apply(newArray, __spreadArray([atIndex, 0], itemsToAdd, false));
    return newArray;
}
// don't call this directly, but use above functions
function rearrangeItemInArray(array, oldIndex, newIndex) {
    if (newIndex && newIndex >= array.length) {
        newIndex = array.length - 1;
    }
    var newArray = __spreadArray([], array, true);
    if (newIndex !== undefined) {
        // if newIndex is provided, swap image position
        newArray.splice(newIndex, 0, newArray.splice(oldIndex, 1)[0]);
    }
    else {
        // otherwise, delete image at index provided
        newArray.splice(oldIndex, 1);
    }
    return newArray;
}
